import { create } from "zustand";

/**
 * 部署轨道。网关按 PRE 名单裁决当前账号走哪个后端池，并在响应头 `X-Deployment-Track` 回传结果。
 * - `A`：稳定轨道（默认，多数运营）
 * - `PRE`：预发布轨道（在名单里的运营）
 * - `null`：尚未收到任何带该头的响应（未登录或首屏未发请求）
 */
export type DeploymentTrack = "A" | "PRE" | null;

interface DeployTrackState {
	/** 网关裁决出的后端轨道 */
	track: DeploymentTrack;
	setTrack: (track: DeploymentTrack) => void;
}

/**
 * 部署轨道状态。由 apiClient 的响应拦截器写入，页头角标读取。
 * <p>
 * 只反映**后端池**的裁决结果；当前页面加载的是哪套前端产物由 nginx 按 deploy_pool cookie 决定。
 * 两者可能短暂不一致（刚被加入名单、还没刷新），角标据此提示用户刷新对齐。
 */
export const useDeployTrackStore = create<DeployTrackState>((set) => ({
	track: null,
	setTrack: (track) => set({ track }),
}));

/** 供非 React 上下文（axios 拦截器）写入 */
export const setDeploymentTrack = (track: DeploymentTrack) => {
	if (useDeployTrackStore.getState().track !== track) {
		useDeployTrackStore.getState().setTrack(track);
	}
};
